import React from 'react';
import LargeContainer from '@/components/front-office/containers/LargeContainer';

const MentionsLegales = () => {
  return (
    <LargeContainer>
      <div className="container mx-auto px-4 py-4 max-h-[60vh] overflow-y-auto">
        <h1 className="text-3xl font-bold mb-6">Mentions Légales</h1>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Éditeur du site</h2>
          <p className="mb-4">
            Dénomination sociale : RIVKA TRAITEUR<br />
            Forme juridique : SAS (Société par Actions Simplifiée)<br />
            Capital social : 1 000 €<br />
            Siège social : 19 rue du Petit Bois, 93100 Montreuil<br />
            Numéro SIREN : 921 812 855<br />
            Numéro SIRET (siège) : 921 812 855 00010<br />
            Numéro de TVA intracommunautaire : FR05921812855<br />
            Adresse de courrier électronique : rivka.traiteur@gmail.com<br />
            Numéro de téléphone : 06 20 20 20 20
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Directeur de la publication</h2>
          <p className="mb-4">
            Nom : Madame Rivka MARUANI<br />
            Fonction : Présidente
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Hébergeur du site</h2>
          <p className="mb-4">
            Nom : Hostinger<br />
            Adresse : Hostinger International Ltd., 61 Lordou Vironos Street, 6023 Larnaca, Chypre<br />
            Numéro de téléphone : [Hostinger ne fournit pas de support téléphonique; veuillez utiliser leur chat en direct disponible 24h/24 et 7j/7 via leur site web]
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Propriété intellectuelle</h2>
          <p className="mb-4">
            Le contenu du site app.rivkatraiteur.com, incluant textes, images, graphismes, logo, icônes et autres éléments, est la propriété exclusive de RIVKA TRAITEUR, sauf mention contraire. Toute reproduction, distribution, modification, adaptation, retransmission ou publication de ces éléments est strictement interdite sans l'accord écrit de RIVKA TRAITEUR.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Données personnelles</h2>
          <p className="mb-4">
            RIVKA TRAITEUR s'engage à ce que la collecte et le traitement de vos données, effectués à partir du site app.rivkatraiteur.com, soient conformes au Règlement Général sur la Protection des Données (RGPD). Pour toute information ou exercice de vos droits Informatique et Libertés sur les traitements de données personnelles gérés par RIVKA TRAITEUR, vous pouvez contacter [Nom du responsable] à l'adresse [adresse email de contact].
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Cookies</h2>
          <p className="mb-4">
            Le site app.rivkatraiteur.com peut collecter automatiquement des informations standards, ainsi que des données personnalisées permettant de reconnaître ses visiteurs lors de leurs visites suivantes. Toutes les informations collectées indirectement ne seront utilisées que pour suivre le volume, le type et la configuration du trafic utilisant ce site, pour en développer la conception et l'agencement, et à d'autres fins administratives et de planification, afin d'améliorer le service offert.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Liens hypertextes</h2>
          <p className="mb-4">
            Le site app.rivkatraiteur.com peut contenir des liens hypertextes vers d'autres sites présents sur le réseau Internet. Les liens vers ces autres ressources vous font quitter le site app.rivkatraiteur.com. Il est possible de créer un lien vers la page de présentation de ce site sans autorisation expresse de RIVKA TRAITEUR. Toutefois, RIVKA TRAITEUR se réserve le droit de demander la suppression d’un lien qu’il estime non conforme à l’objet du site app.rivkatraiteur.com.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Responsabilité</h2>
          <p className="mb-4">
            Les informations proposées sur le site app.rivkatraiteur.com sont fournies à titre informatif. RIVKA TRAITEUR ne saurait garantir l'exactitude, la complétude ou l'actualité des informations diffusées sur le site. Vous êtes seul responsable de l'utilisation que vous faites du contenu du site app.rivkatraiteur.com. Sauf faute grave exclusive de RIVKA TRAITEUR, sa responsabilité ne peut être engagée qu'en cas de dommages directs résultant de l'utilisation du site.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Modification des mentions légales</h2>
          <p className="mb-4">
            RIVKA TRAITEUR se réserve le droit de modifier les présentes mentions à tout moment. L'utilisateur s'engage donc à les consulter régulièrement.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Droit applicable</h2>
          <p className="mb-4">
            Le présent site est soumis au droit français.
          </p>
        </section>
        </div>
    </LargeContainer>
  );
};

export default MentionsLegales; 